var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosMetadata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 239,
    viewBox: "0 0 235 239",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0328 237.909C40.2162 237.784 20.3996 237.66 0.00013639 237.531C0.130931 216.717 0.257878 196.514 0.388672 175.7C20.2053 175.824 40.0219 175.949 60.4213 176.077C60.2944 196.28 60.1636 217.094 60.0328 237.909Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.805 238.385C115.988 238.26 96.1718 238.136 75.7724 238.008C75.9031 217.193 76.0301 196.991 76.1609 176.176C95.9775 176.301 115.794 176.425 136.194 176.553C136.067 196.756 135.936 217.57 135.805 238.385Z",
    fill: "#FF7A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.806 161.731C193.989 161.606 174.172 161.482 153.773 161.353C153.904 140.539 154.031 120.337 154.161 99.5223C173.978 99.6469 193.795 99.7714 214.194 99.8996C214.067 120.102 213.936 140.916 213.806 161.731Z",
    fill: "#FF7A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.873 161.245C117.057 161.12 97.2402 160.996 76.8407 160.868C76.9715 140.053 77.0985 119.851 77.2292 99.0367C97.0458 99.1613 116.862 99.2858 137.262 99.414C137.131 120.228 137.004 140.431 136.873 161.245Z",
    fill: "#FF7A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.129 238.486C152.26 217.671 152.387 197.469 152.517 176.654C172.334 176.779 192.15 176.903 212.55 177.032C212.419 197.846 212.292 218.048 212.161 238.863C192.345 238.738 172.528 238.614 152.129 238.486Z",
    fill: "#FF7A00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 81.2913C77.473 60.4768 77.5999 40.2746 77.7307 19.4601C97.5473 19.5846 117.364 19.7091 137.763 19.8373C137.633 40.6518 137.506 60.8541 137.375 81.6685C117.558 81.544 97.7416 81.4195 77.3422 81.2913Z",
    fill: "#FF7A00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96484 18.3698C21.7815 18.4943 41.5981 18.6188 61.4147 18.7433C61.2839 39.5578 61.157 59.7601 61.0262 80.5745C41.2096 80.45 21.3929 80.3255 1.57631 80.201C1.70326 59.9987 1.8302 39.7964 1.96484 18.3698Z",
    fill: "#FF7A00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08144 159.169C1.21223 138.355 1.33918 118.153 1.46997 97.3384C21.2866 97.4629 41.1032 97.5874 61.5026 97.7156C61.3719 118.53 61.2449 138.732 61.1141 159.547C40.7147 159.419 20.898 159.294 1.08144 159.169Z",
    fill: "#FF7A00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.83 78.4984C198.048 72.8642 179.432 67.2373 159.654 60.9908C165.026 40.8215 170.395 21.2644 175.767 1.0951C195.549 6.72933 214.749 12.3599 233.944 18.6027C228.575 38.1598 223.203 58.3291 217.83 78.4984Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosMetadata);
export default __webpack_public_path__ + "static/media/logos_metadata.2e2ab9775b4527890cdd3f5c598e55ea.svg";
export { ForwardRef as ReactComponent };